export enum CustomDateDisplayEnum {
    YMD_Slashes = 0,
    DMY_Slashes = 1,
    MDY_Slashes = 2,
    YMD_Dashes = 3,
    DMY_Dashes = 4,
    MDY_Dashes = 5,
}